import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { useShoppingCart } from '../../providers/shoppingcart.provider';
import { SortProductsItem } from './models';

export const useFilteredCrossSellItems = (): SortProductsItem[] => {
  const items = useSelector((state: ApplicationState) => state.crossSell.items);
  const { cart } = useShoppingCart();

  return useMemo(() => {
    const cartSkus = cart.map((item) => String(item.sku));
    return items.filter(
      (product) =>
        !cartSkus.includes(String(product.sku)) &&
        product.price?.creditPrice &&
        product.price?.creditPrice !== '' &&
        Number(product.price?.creditPrice) > 0
    );
  }, [items, cart]);
};
